import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AlertDialogComponent, AlertDialogData } from 'src/app/common/modals/alert-dialog/alert-dialog.component';
import { MenuDialogComponent, MenuDialogData } from 'src/app/common/modals/menu-dialog/menu-dialog.component';
import { LogService } from 'src/app/services/log/log.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { SurveyService } from 'src/app/services/survey/survey.service';
import { SnackbarService } from './../../../../services/snackbar/snackbar.service';

@Component({
  selector: 'app-survey-reaction',
  templateUrl: './survey-reaction.component.html',
  styleUrls: ['./survey-reaction.component.scss'],
})
export class SurveyReactionComponent implements OnInit {

  constructor(
    private modalService: ModalService, 
    private surveyService: SurveyService,
    private logService: LogService,
    private snackbarService: SnackbarService
  ) { }

  @Input() surveyId: number | undefined;
  @Input() commentId: number | undefined;
  @Input() isLikeClicked: boolean = false;
  @Input() likeCount: number = 0;
  @Input() showComment: boolean = false;
  @Input() showOption = true;
  @Input() commentCount: number = 0;
  @Input() isWriter: boolean = false;
  @Input() type: 'post' | 'comment' | undefined
  @Input() location: 'home' | 'result' = 'home';
  @Output() onClickComment = new EventEmitter<void>();
  @Output() onClickLike = new EventEmitter<boolean>();

  ngOnInit() {}

  onClickLikeButton(): void {
    if (this.commentId === undefined) {
      return;
    }
    if (this.isLikeClicked) {
      this.logService.survey.surveyResultCommentLikeUnsetClicked(this.commentId)
    } else {
      this.logService.survey.surveyResultCommentLikeSetClicked(this.commentId)
    }
    this.onClickLike.emit(!this.isLikeClicked);
    if (this.type === 'post') {
      this.surveyService.likeComment(this.commentId, this.isLikeClicked).subscribe(() => {
        this.isLikeClicked = !this.isLikeClicked;
        this.likeCount += this.isLikeClicked ? 1 : -1;
      })
    } else {
      this.surveyService.likeComment(this.commentId, this.isLikeClicked).subscribe(() => {
        this.isLikeClicked = !this.isLikeClicked;
        this.likeCount += this.isLikeClicked ? 1 : -1;
      })
    }
  }

  async onClickOption(): Promise<void> {
    if (this.commentId !== undefined) {
      const menuDialog = await this.modalService.openMenuDialog(MenuDialogComponent, { data: this.getMenuDialogData(this.commentId) });
      await menuDialog.present();
    }
  }
  private getMenuDialogData(id: number): MenuDialogData[] {
    const menu: MenuDialogData[] = [
      {
        text: '취소',
        role: 'cancel',
        action: () => {}
      }
    ]
    if (this.isWriter) {
      menu.unshift({
        text: '삭제',
        role: 'destructive',
        action: () => {
          this.openConfirmDialog(id, 'delete');
        }
      })
    } else {
      menu.unshift({
        text: '신고',
        action: () => {
          this.openConfirmDialog(id, 'report');
        }
      })
    }
    return menu;
  }

  private async openConfirmDialog(id: number, type: 'delete' | 'report'): Promise<void> {
    const dialog = await this.modalService.openDialog(AlertDialogComponent, {
      data: type === 'delete' ? this.deleteDialogData(id) : this.reportDialogData(id)
    });
    await dialog.present();
  }

  private deleteDialogData(id: number): AlertDialogData {
    return {
      image: 'assets/icons/icon-trash-bin.png',
      title: `정말로 이 댓글을 삭제할까요?`,
      description: '이 행동은 취소할 수 없습니다.',
      buttons: [
        { text: '취소', role: 'cancel'},
        { text: '삭제', role: 'confirm', action: () => this.delete(id) }
      ]
    }
  }

  private reportDialogData(id: number): AlertDialogData {
    return {
      image: 'assets/icons/icon-trash-bin.png',
      title: `이 댓글을 신고할까요?`,
      description: `다음과 같은 경우에 신고해 주세요.<br /> -  욕설 또는 선정적인 내용이 포함된 경우<br /> -  타인을 비방하거나 공격적인 내용이 포함된 경우<br /> -  커뮤니티의 성격을 심각히 저해하는 경우`, 
      buttons: [
        { text: '취소', role: 'cancel'},
        { text: '신고', role: 'confirm', action: () => this.report(id) }
      ]
    }
  }

  private delete(id: number): Observable<void> {
    return this.surveyService.deleteComment(id).pipe(tap(() => {
      this.logService.survey.surveyResultCommentsDeleted(id);
      this.snackbarService.openSnackBar(SnackbarService.SURVEY_COMMENT_DELETED);
    }));
  }

  private report(id: number): Observable<void> {
    return this.surveyService.reportComment(id).pipe(tap(() => {
      this.logService.survey.surveyResultCommentsReported(id);
      this.snackbarService.openSnackBar(SnackbarService.SURVEY_REPORT_SUBMITTED);
    }));
  }
  
}
